import React, { useEffect, useState } from 'react';
import { CategorySelector } from './CategorySelector';
import { ItemSelector } from './ItemSelector';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
interface BottomPanelProps {
  selectedCategory: string;
  selectedItem: string;
  onCategorySelect: (category: string) => void;
  onItemSelect: (item: string) => void;
  onAddToCart: (item: {
    id: string;
    name: string;
    price: number;
    category: string;
  }) => void;
  onRemoveFromCart?: (item: {
    id: string;
    name: string;
    price: number;
    category: string;
  }) => void;
  hoveredCategory: string;
  forceExpand?: boolean;
  shouldCollapse?: boolean;
  cartItems?: Array<{
    id: string;
    name: string;
    price: number;
    category: string;
  }>;
}
export const BottomPanel = ({
  selectedCategory,
  selectedItem,
  onCategorySelect,
  onItemSelect,
  onAddToCart,
  onRemoveFromCart,
  hoveredCategory,
  forceExpand = false,
  shouldCollapse = false,
  cartItems = []
}: BottomPanelProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);

    // If closing the panel, clear the category selection
    if (isExpanded) {
      onCategorySelect('');
    }
  };
  // Auto-expand panel when a category is selected (e.g., by clicking on 3D objects)
  useEffect(() => {
    if (selectedCategory) {
      setIsExpanded(true);
    }
  }, [selectedCategory]);
  // Force expand when explicitly triggered (e.g., clicking same object again)
  useEffect(() => {
    if (forceExpand) {
      setIsExpanded(true);
    }
  }, [forceExpand]);

  // Auto-collapse panel when navigation occurs
  useEffect(() => {
    if (shouldCollapse && isExpanded) {
      setIsExpanded(false);
    }
  }, [shouldCollapse, isExpanded]);
  return <div className={`absolute bottom-0 left-0 right-0 bg-white bg-opacity-90 backdrop-blur-sm shadow-lg transition-all duration-500 ease-in-out transform ${isExpanded ? 'h-auto max-h-[60vh] pb-2' : 'h-16 translate-y-0'}`} style={{
    overflow: 'visible',
    zIndex: 10
  }} data-id="element-7">
      <div className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full cursor-pointer bg-white px-4 py-1 rounded-t-lg shadow-lg transition-all duration-300 hover:bg-gray-50 ${isExpanded ? 'bg-orange-50' : ''}`} onClick={toggleExpanded} style={{
      zIndex: 50
    }} data-id="element-8">
        {isExpanded ? <ChevronDownIcon size={20} className="text-orange-500 transition-transform duration-300 transform hover:scale-110" data-id="element-9" /> : <ChevronUpIcon size={20} className="transition-transform duration-300 transform hover:scale-110" data-id="element-10" />}
      </div>
      <div className="max-h-full relative" style={{
      overflow: 'visible'
    }} data-id="element-11">
        {/* Categories */}
        <CategorySelector selectedCategory={selectedCategory} hoveredCategory={hoveredCategory} isExpanded={isExpanded} onCategorySelect={category => {
        onCategorySelect(category);
        setIsExpanded(true);
      }} data-id="element-12" />
        {/* Items for selected category */}
        {selectedCategory && isExpanded && <ItemSelector category={selectedCategory} selectedItem={selectedItem} onItemSelect={onItemSelect} onAddToCart={onAddToCart} onRemoveFromCart={onRemoveFromCart} cartItems={cartItems} data-id="element-13" />}
      </div>
    </div>;
};